const LegalNotice = () => {
  return <div>Mentions légales</div>;
};

export default LegalNotice;
